<div class="update-status-container">
  <!-- Dialog Header -->
  <div class="dialog-header d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
    <h5 class="m-0 fw-semibold text-primary d-flex align-items-center gap-2">
      <mat-icon color="primary">update</mat-icon>
      Update Status
    </h5>
    <button mat-icon-button mat-dialog-close aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="statusUpdateForm" (ngSubmit)="onSubmit()">
    <div class="dialog-body p-3">
      <!-- Item summary info if available -->
      <div *ngIf="data?.item" class="item-summary-card p-2 mb-3 rounded border">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="fw-semibold text-dark">
            {{ data.item.category_name || 'Issue #' + data.item.issue_id }}
          </span>
          <div class="badges d-flex gap-1">
            <span *ngIf="data.item.block" class="badge bg-light text-dark border">
              Wing {{ data.item.block }}
            </span>
            <span *ngIf="data.item.floor_unit" class="badge bg-light text-dark border">
              Unit {{ data.item.floor_unit }}
            </span>
          </div>
        </div>
        <div *ngIf="data.item.description" class="small text-muted text-truncate">
          {{ data.item.description }}
        </div>
      </div>

      <!-- Select Status field using Searchable Dropdown -->
      <div class="mb-3">
        <label class="form-label fw-medium text-dark small mb-1">
          Select Status <span class="text-danger">*</span>
        </label>
        <app-searchable-dropdown
          formControlName="status"
          [options]="statusList | searchableOptions:'status':'status_id'"
          placeholder="Select Status"
          class="w-100 filter-dropdown"
        ></app-searchable-dropdown>
        <div *ngIf="statusUpdateForm.get('status')?.touched && statusUpdateForm.get('status')?.hasError('required')" class="text-danger small mt-1">
          Status is required
        </div>
      </div>

      <!-- Comment field -->
      <div class="mb-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comment / Note</mat-label>
          <textarea
            matInput
            formControlName="comment"
            rows="3"
            placeholder="Enter comment or details for this status update...">
          </textarea>
          <mat-error *ngIf="statusUpdateForm.get('comment')?.hasError('required')">
            Comment is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Dialog Actions -->
    <div class="dialog-actions d-flex justify-content-end align-items-center px-3 py-2 border-top gap-2">
      <button mat-button type="button" mat-dialog-close [disabled]="submitting()">
        Cancel
      </button>
      <button mat-raised-button color="primary" type="submit" [disabled]="submitting()">
        <span *ngIf="submitting()" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Submit
      </button>
    </div>
  </form>
</div>
